import { Injectable } from '@angular/core';
import { Query, gql, Mutation } from 'apollo-angular';

import {
  PatientDemographics,
  UpdatePatient,
  UpdatePatientVariables,
} from '@app/shared/review-demographics/graphql/__generated__/patient-demographics-graphql.service.types';

@Injectable()
export class PatientDemographicsGraphQLService extends Query<PatientDemographics> {
  document = gql`
    query PatientDemographics {
      patient {
        dob
        firstName
        genderDetails
        id
        lastName
        middleName
        phoneNumbers {
          id
          isPreferred
          kind
          numberFormatted
        }
        primaryAddress {
          id
          address1
          address2
          city
          state
          zip
        }
        preferredEmail {
          id
          email
        }
        pronounGroup
        preferredName
        sex
        suffix
      }
    }
  `;
}

@Injectable({
  providedIn: 'root',
})
export class UpdatePatientGraphQLService extends Mutation<UpdatePatient, UpdatePatientVariables> {
  document = gql`
    mutation UpdatePatient($input: UpdatePatientInput!) {
      updatePatient(input: $input) {
        success
        errors
        patient {
          id
          preferredName
          genderDetails
          pronounGroup
          primaryAddress {
            id
            address1
            address2
            city
            state
            zip
          }
        }
      }
    }
  `;
}
